import { instance3 } from "App/constants";
import { today } from "App/utils/helpers";

export const RESET_STATE_SERVICE_TUTUP_TAGIHAN = {
  id: "",
  date: today(),
  keterangan: "",
  tipe_pembayaran_id: 1,
  kas_id: null,
  kas_name: "Pilih Kas",
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_tagihan",
    disablePadding: false,
    label: "TGL TAGIHAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "keterangan",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWidth: "100px",
  },
];

export const headCellsService = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },

  {
    id: "tipe_pembayaran_id",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    align: "left",
    minWIdth: "150px",
  },

  {
    id: "kas_name",
    disablePadding: false,
    label: "KAS",
    align: "left",
    minWIdth: "100px",
  },

  {
    id: "keterangan",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWIdth: "100px",
  },

  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  tipe_pembayaran_id: "",
  kas_id: null,
  kas_name: "Pilih Kas",
};

export const getByServiceTutupTagihan = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post("/servpemb_tagihan/list", {
      halaman: pages,
      jumlah: limit,
      kas_id: formFilter.kas_id,
      tipe_pembayaran_id: formFilter.tipe_pembayaran_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.totalData),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteServiceTutupTagihanById = async (id) => {
  try {
    const api = await instance3.post("/servpemb_tagihan/delete", {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};
